
import React, { useEffect, useState } from 'react';
import LoadingOverlay from '../components/General/LoadingOverlay';
import useGlobal from '../store';
import ReactGA from 'react-ga';
import * as utils from '../services/utils';
import CurrencySymbol from '../components/General/CurrencySymbol';
import SelectUser from '../components/General/SelectUser';

const GiftIdeaPage = (props) => {

    const [giftidea, giftideaActions] = useGlobal(
        state => state.giftidea,
        actions => actions.giftideaActions
    );
    const [user] = useGlobal(
        state => state.user
    );
    const [response] = useGlobal(
        state => state.response
    );

    const [isSaving, setIsSaving] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        console.log('get gift idea', props.match.params.gid);
        giftideaActions.getGiftIdea(props.match.params.gid);
    }, [giftideaActions, props.match.params.gid]);

    useEffect(() => {
        if(!response || response.type !== "addgiftidea") {
            return;
        }
        setIsSaving(false);
    }, [response]);


    const domain = function(input) {
        input = Array.isArray(input) ? input[0] : input;
        input = input.replace('www.', '');
        var l = document.createElement("a");
        l.href = input;
        return l.hostname;
    }

    const getItemUrl = (item) => {
        if(item.affURL) {
            return item.affURL;
        }
        if(!item.itemURLs || item.itemURLs === "") {
            return "#";
        }
        if(item.itemURLs.indexOf('amazon.com') !== -1 
            || item.itemURLs.indexOf('amazon.co.uk') !== -1
            || item.itemURLs.indexOf('amazon.de') !== -1
            || item.itemURLs.indexOf('amazon.fr') !== -1
            || item.itemURLs.indexOf('amazon.es') !== -1) {
            return formatAmazonUrl(item.itemURLs);
        } 
        return "http://go.redirectingat.com/?id=86675X1539295&xs=1&url="+encodeURI(item.itemURLs)+"&sref="+encodeURI(window.location.href);
    }
    const formatAmazonUrl = (linkUrl) => {
        linkUrl = decodeURIComponent(linkUrl);
        if(linkUrl.indexOf('christmasli0b-20') === -1) {
            var parts = linkUrl.split("?");
            if(parts.length > 1) {
                var params = JSON.parse('{"' + decodeURI(parts[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
                params.tag = "christmasli0b-20";
                var queryString = Object.keys(params)
                        .map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) })
                        .join('&');
                linkUrl = parts[0] + "?" + queryString;
            } else {
                linkUrl += "?tag=christmasli0b-20"; 
            }
        }
        return linkUrl;
    }

    const openLink = (item) => {
        let itemUrl = getItemUrl(item);
        if(!itemUrl || itemUrl === "#") {
            return;
        }
        window.open(itemUrl, '_blank');

        //TRACK REFERRAL CLICK EVENT
        let domain = utils.getDomain(item.itemURLs);
        let evtVal = item.itemPrice ? parseInt(item.itemPrice, 10) : 1;
        ReactGA.event({
            category: 'Referral Click',
            action: 'Giftidea Item',
            label: domain,
            value: evtVal
        });
    }

    const selectedUserChanged = (selectedUserData) => {
        console.log('NEW SELECTED USER', selectedUserData);
        setSelectedUser(selectedUserData);
    }

    const addGiftIdea = () => {
        console.log('ADD GIFT IDEA: ' + giftidea.ideaID + ' TO USER: ' + selectedUser.userID);
        setIsSaving(true);
        let data = {
            id: giftidea.ideaID,
            user_id: selectedUser.userID
        };
        console.log('ADD GIFT IDEA', data);
        giftideaActions.addGiftIdea(data);
    }

    return (<>
        <div className="mt-4 kt-container kt-grid__item kt-grid__item--fluid">
            <div className="row">	
                <div className="col-sm-12">
                    {giftidea && user ? 
                        <div className="kt-portlet kt-portlet--height-fluid kt-widget-12">
                            <div className="kt-portlet__head">
                                <div className="kt-portlet__head-label">
                                    <h3 className="kt-portlet__head-title">{giftidea.itemName}</h3>
                                </div>
                            </div>
                            <div className="kt-portlet__body">
                                <div onClick={() => openLink(giftidea)} style={{display: "flex", alignItems: "center", cursor:"pointer"}}>
                                    <img alt="Product" style={{maxHeight: "200px"}} className="mr-3" src={giftidea.itemPic} />
                                    <div>
                                        <h3>Price: <CurrencySymbol></CurrencySymbol>{giftidea.itemPrice}</h3>
                                        { (giftidea.itemURLs && giftidea.itemURLs !== "") ? <p className="card-text">{domain(giftidea.itemURLs)} <i className="flaticon2-tag"></i></p> : <></> }
                                        { (giftidea.itemURLs && giftidea.itemURLs !== "") ? <p className="card-text">View Online <i className="la la-external-link"></i></p> : <></> }
                                    </div>
                                </div>
                                <p>{giftidea.itemDescription}</p>
                            </div>
                            <div className="kt-portlet__foot kt-portlet__foot--md">
                                <div className="kt-portlet__foot-wrapper">
                                    <div>
                                        <SelectUser onChange={selectedUserChanged} selectedUser={selectedUser}></SelectUser>

                                        <button onClick={() => addGiftIdea()} className="mt-2 btn btn-bold btn-danger btn-upper">
                                            <i className="flaticon2-plus-1"></i> Add This Gift 
                                            { isSaving ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></> }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    : <LoadingOverlay></LoadingOverlay>}
                </div>
            </div>
        </div>
    </>);
}
export default GiftIdeaPage;